import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 5px;

  width: 100%;
  height: 100%;

  svg {
    margin-bottom: 10px;
  }
`